<template>
  <div class="page-body">
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-6">
            <h3></h3>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <Loader :loading="isLoading" />
        <loader-component v-if="isLoading" :loading="isLoading" />
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body add-post">
                <div class="row my-3">
                  <!-- Mostrar: dropdown para seleccionar registros por página -->
                  <div class="d-flex align-items-center mb-3">
                    <span class="me-2">Mostrar:</span>
                    <select 
                      v-model="usersPerPage" 
                      @change="resetPagination"
                      class="form-select w-auto px-4 py-[9px] bg-white rounded-md text-black text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                    >
                      <option :value="10">10</option>
                      <option :value="50">50</option>
                      <option :value="100">100</option>
                    </select>
                    <span class="ms-2">registros</span>
                  </div>
                  <div class="filters-container d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
                    <!-- Botón a la izquierda -->
                        <button>
                            <span class="custom-create-btn-text"></span>
                        </button>
                    <!-- Contenedor de filtros a la derecha -->
                    <div class="filters-group d-flex align-items-center gap-2">
                      <select 
                        v-model="selectedReason" 
                        class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                      >
                        <option value="">Todos los motivos</option>
                        <option 
                          v-for="reason in reportReasons" 
                          :key="reason.id" 
                          :value="reason.id"
                        >
                          {{ reason.name }}
                        </option>
                      </select>
                      <!-- Input del buscador -->
                      <input
                        type="text"
                        class="w-64 px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                        placeholder="Buscar"
                        v-model="searchQuery"
                      />
                    </div>
                  </div>  
                </div>
                <div class="row my-3">
                  <div class="w-full">
                    <div class="tab-content" id="reportsTabsContent">
                      <!-- Tabla de Reportes -->
                      <div class="tab-pane fade show active" id="reports" role="tabpanel" aria-labelledby="reports-tab">
                        <div class="overflow-x-auto">
                          <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-100 text-gray-600 uppercase text-sm leading-normal">
                              <tr>
                                <th class="py-3 px-6 text-style-custom text-left">ID Reporte</th>
                                <th class="py-3 px-6 text-style-custom text-left">Fecha</th>
                                <th class="py-3 px-6 text-style-custom text-left">Motivo</th>
                                <th class="py-3 px-6 text-style-custom text-left">Propiedad</th>
                                <th class="py-3 px-6 text-style-custom text-left">ID Propiedad</th>
                                <th class="py-3 px-6 text-style-custom text-left">Descripción</th>
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                              <tr
                                v-for="(report, index) in filteredReports"
                                :key="index"
                                class="border-b border-gray-200 hover:bg-gray-100"
                              >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ report.id }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ formattedDate(report.created_at) }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">{{ report.report_reason?.name || 'Desconocido' }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <a 
                                    :href="(report.property?.url)" 
                                    target="_blank"
                                    class="text-red-500 underline hover:text-red-700"
                                  >
                                    {{ report.property?.name || 'N/A' }}
                                  </a>
                                </td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <a 
                                    :href="`/properties/form/${report.property?.id}`" 
                                    target="_blank"
                                    class="text-red-500 underline hover:text-red-700"
                                  >
                                    {{ report.property?.id || 'N/A' }}
                                  </a>
                                </td>
                                <td class="py-3 px-6 custom-width-text break-words whitespace-normal">
                                  {{ report.description || 'Sin descripción' }}
                                </td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-200"
                                      @click.stop="toggleMenu(report.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div 
                                      v-show="menuVisible === report.id" 
                                      :class="{
                                        'absolute right-0 bg-white border shadow-lg mt-1 w-48 z-10': true,
                                        'bottom-full mb-1': index === filteredReports.length - 1, // Si es el último registro, despliega hacia arriba
                                        'top-full mt-1': index !== filteredReports.length - 1 // De lo contrario, despliega hacia abajo
                                      }"
                                    >
                                      <ul class="py-1">
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer" @click="readReports(report)">Ver detalle</li>
                                        <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer text-red-500" @click="openDeleteModal(report.id)">Eliminar</li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Modal de confirmación de eliminación -->
                  <DeleteModal 
                    :visible="showDeleteModal" 
                    @close="closeDeleteModal"
                    @confirm="handleConfirmDelete"
                  />
                </div>
                
                <!-- Paginación -->
                <div class="pagination-wrapper">
                  <button 
                    @click="changePage(page - 1)" 
                    :disabled="page === 1"
                    class="pagination-btn"
                    :class="{ 'disabled-btn': page === 1 }"
                  >Anterior
                  </button>
                  <template v-for="(pageNumber, index) in visiblePages">
                    <button
                      v-if="pageNumber !== '...'"
                      :key="`page-${index}`"
                      @click="changePage(pageNumber)"
                      class="page-number"
                      :class="{ 'active-page': pageNumber === page }"
                    >{{ pageNumber }}</button>
                    <span v-else :key="`dots-${index}`" class="px-2">...</span>
                  </template>
                  <button 
                    @click="changePage(page + 1)" 
                    :disabled="page >= totalPages"
                    class="pagination-btn"
                    :class="{ 'disabled-btn': page >= totalPages }"
                  >Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import Loader from '@/components/loaderComponent.vue';
import DeleteModal from '@/components/reports/Modal/DeleteReportComponent.vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const isLoading = ref(true);
const reports = ref([]);
const reportReasons = ref([]);
const searchQuery = ref('');
const selectedReason = ref('');
const page = ref(1);
const usersPerPage = ref(10);
const totalPages = ref(1);
const showDeleteModal = ref(false);
const reportToDelete = ref(null);
const menuVisible = ref(null);
const menuContainers = ref([]);

const store = useStore();
const session = computed(() => store.getters.getUserSession);

// Obtener reportes
const fetchReports = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/reports-all`,
      {
        headers: { 
          Authorization: `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json'
        },
        params: {
          page: page.value,
          per_page: usersPerPage.value,
          reason_id: selectedReason.value,
          search: searchQuery.value
        }
      }
    );

    if (response.status === 200) {
      reports.value = response.data.resp || [];
      totalPages.value = response.data.pagination?.last_page || 1;
    }
  } catch (error) {
    console.error("Error fetching reports:", error);
  } finally {
    isLoading.value = false;
  }
};

// Obtener motivos de reporte
const fetchReportReasons = async () => {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/catalogue-reports`,
      {
        headers: { 
          Authorization: `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json'
        }
      }
    );
    
    if (response.status === 200) {
      reportReasons.value = response.data.resp || [];
    }
  } catch (error) {
    console.error("Error fetching report reasons:", error);
  }
};

// Formatear fecha a formato legible
const formattedDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString("es-ES", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  }).replace(/a\.\s?m\./gi, "a.m.").replace(/p\.\s?m\./gi, "p.m.");
};

// Filtra reportes según búsqueda y motivo seleccionado
const filteredReports = computed(() => {
  let result = reports.value;
  
  if (selectedReason.value) {
    result = result.filter(report => 
      report.report_reason?.id === selectedReason.value
    );
  }
  
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase();
    result = result.filter(report => 
      (report.description?.toLowerCase().includes(query)) ||
      (report.property?.name?.toLowerCase().includes(query)) ||
      (report.property?.id?.toString().includes(query)) ||
      (report.report_reason?.name?.toLowerCase().includes(query))
    );
  }
  
  return result;
});

// Generar rango de páginas visibles para paginación
const visiblePages = computed(() => {
  const total = totalPages.value;
  
  if (total <= 5) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }
  
  const current = page.value;
  let pages = [];
  pages.push(1);
  
  let start = Math.max(2, current - 1);
  let end = Math.min(total - 1, current + 1);
  
  if (start > 2) {
    pages.push('...');
  }
  
  for (let i = start; i <= end; i++) {
    pages.push(i);
  }
  
  if (end < total - 1) {
    pages.push('...');
  }
  
  pages.push(total);
  
  return pages;
});

// Método para cambiar página
const changePage = (newPage) => {
  if (newPage >= 1 && newPage <= totalPages.value) {
    page.value = newPage;
    fetchReports();
  }
};

// Resetear paginación cuando cambian los filtros
const resetPagination = () => {
  page.value = 1;
  fetchReports();
};

const openDeleteModal = (reportId) => {
  reportToDelete.value = reportId;
  showDeleteModal.value = true;
};

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  reportToDelete.value = null;
};

const handleConfirmDelete = async () => {
  if (reportToDelete.value) {
    await deleteReports(reportToDelete.value);
  }
  closeDeleteModal();
};

// Función para eliminar reporte
const deleteReports = async (id) => {
  try {
    isLoading.value = true;
    const response = await axios.delete(
      `${process.env.VUE_APP_API_BASE_URL}/reports-delete/${id}`,
      {
        headers: { 
          Authorization: `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (response.status === 200) {
      // Mostrar mensaje de éxito
      console.log('Reporte eliminado correctamente');
      
      // Recargar la lista de reportes
      await fetchReports();
      
      // Cerrar el modal
      closeDeleteModal();
    }
  } catch (error) {
    console.error("Error eliminando reporte:", error);
    
    // Mostrar mensaje de error
    if (error.response && error.response.data && error.response.data.message) {
      console.error("Error del servidor:", error.response.data.message);
    }
  } finally {
    isLoading.value = false;
  }
};

// Función para abrir modal de solo lectura
const readReports = (report) => {
  // Navegar a la vista de detalle del reporte
  router.push({
    name: 'read-report',
    params: { id: report.id } // Pasar el ID como parámetro
  });
};


const handleClickOutside = (event) => {
  if (!menuContainers.value.some(container => container?.contains(event.target))) {
    menuVisible.value = null;
  }
};

const toggleMenu = (userId) => {
  menuVisible.value = menuVisible.value === userId ? null : userId;
};


watch([searchQuery, selectedReason, usersPerPage], () => {
  page.value = 1;
  fetchReports();
});

watch(page, () => {
  fetchReports();
});

onMounted(async () => {
  await fetchReportReasons();
  await fetchReports();
  document.addEventListener('click', handleClickOutside);
});
</script>
  
<style scoped>
.card {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: none;
  border-radius: 8px;
}
.controls-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1.5rem;
  flex-wrap: wrap;
}

.pagination-wrapper button {
  padding: 8px 12px;
  border: 1px solid #FFD8DF;
  background: #FFF;
  color: #FF4265;
  cursor: pointer;
  min-width: 40px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin: 0;
  border-radius: 0; 
}

.pagination-wrapper button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.pagination-wrapper button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.pagination-wrapper button:not(:first-child) {
  margin-left: -1px;
}

.pagination-wrapper button.active-page {
  background: #FF4265;
  color: #FFF;
  font-weight: 500;
  position: relative; 
  z-index: 1;
}

.pagination-wrapper button.disabled-btn {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-btn {
  padding: 8px 16px;
}

.page-number {
  padding: 8px 12px;
}

.page-number.active {
  background: #FF4265;
  color: white;
}
.status-indicator {
  display: inline-block;
  padding: 0.2rem 0.5rem;    
  border-radius: 9999px;
  color: #4A4A4A;
  text-align: center;
  font-size: 0.875rem; 
}
.bg-yellow {
  background-color: #fff3cd;
  color: #664d03;
}
    .bg-red {
    background-color: #f8d7da;
    color: #842029;
    }
    .bg-green {
    background-color: #d1e7dd;
    color: #1c5f48;
    }
    .filters-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    }

    .filters-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    }

    .custom-create-btn {
    padding: 0.5rem 1rem;
    background-color: #FF4265;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    transition: background-color 0.3s ease;
    white-space: nowrap;
    }

    .custom-create-btn:hover {
    background-color: #e03a5f;
    }

    /* Estilos responsivos */
    @media (max-width: 768px) {
    .filters-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    }
  
    .filters-group {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    }
  
    .filters-group select,
    .filters-group input {
    width: 100%;
    }
    }
    @media (min-width: 640px) {
    .filters-group {
    flex-direction: row;
    flex-wrap: wrap;
    }
    .filter-select,
    .search-input {
    width: auto;
    }
    }

    @media (min-width: 768px) {
    .controls-wrapper {
      flex-direction: column; /* Mantener en columna para que "Mostrar" esté arriba */
      align-items: flex-start; /* Alinea a la izquierda */
    }

    .filters-container {
      flex-direction: row;
      justify-content: space-between; /* Mantiene el botón a la izquierda y los filtros a la derecha */
      width: 100%; /* Asegúrate de que ocupe todo el ancho disponible */
      margin-top: 1rem; /* Añade un margen superior para separar "Mostrar" de los filtros */
    }
    .pagination-wrapper {
    overflow-x: auto;
    white-space: nowrap;
    justify-content: flex-end;
    padding-bottom: 8px;
  }

  .pagination-wrapper::-webkit-scrollbar {
    height: 4px;
  }

  .pagination-wrapper::-webkit-scrollbar-thumb {
    background: #FF4265;
    border-radius: 4px;
  }
    }

    @media (min-width: 1024px) {
    .filters-group {
    flex-wrap: nowrap;
    }
    }
    
    .overflow-x-auto {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; 
    }

    @media (max-width: 767px) {
    .custom-width-text {
    min-width: 120px; 
    }
}    
</style>
